module.exports = __webpack_public_path__ + "static/media/04-news.31a5e70b.png";